export const http_error = {
  methods: {
    http_error: function(error){
      // 共通エラーハンドリング
      if(this.$http.isCancel(error)){
        // ユーザーキャンセル
        this.$store.commit("setNotification", {
          type: "info",
          message: {
            eid: "E1" + this.module_id + "001" + ":00000000",
            param: {}
          }
        });
        return false;
      }else if(!error.response){
        // クライアントサイドエラー
        if(error.message && error.message === "Network Error"){
          // ネットワークエラー
          // XmlHttpRequestレベルでは詳細が分からない
          this.$store.commit("setNotification", {
            type: "error",
            message: {
              eid: "E1" + this.module_id + "103" + ":00000000",
              param: {}
            }
          });
        }else if(error.code && error.code === "ECONNABORTED"){
          // ブラウザキャンセルまたはタイムアウト
          this.$store.commit("setNotification", {
            type: "warning",
            message: {
              eid: "E1" + this.module_id + "104" + ":00000000",
              param: {}
            }
          });
        }else{
          // その他
          if(error.message){
            var param = {
              message: error.message
            };
          }else{
            var param = {
              message: "unknown"
            };
          }
          this.$store.commit("setNotification", {
            type: "error",
            message: {
              eid: "E1" + this.module_id + "900" + ":00000001",
              param: param
            }
          });
        }
        return false; // ハンドリング不要
      }else if(error.response.headers["content-type"]
        && error.response.headers["content-type"] === "text/html"){
        // nginx, Flaskによるエラー
        if(error.response.status === 401){
          // 認証関係全般
          this.$store.commit("setNotification", {
            type: "warning",
            message: {
              eid: "E1" + this.module_id + "101" + ":00000000",
              param: {}
            }
          });
          this.$router.push("/");
        }else if(error.response.status === 413){
          // ファイルサイズ超過
          var param = {
            size: 300
          };
          this.$store.commit("setNotification", {
            type: "warning",
            message: {
              eid: "E1" + this.module_id + "102" + ":00000000",
              param: param
            }
          });
        }else{
          // その他エラー
          this.$store.commit("setNotification", {
            type: "error",
            message: {
              eid: "E1" + this.module_id + "301" + ":00000" + error.response.status,
              param: {}
            }
          });
        }
      }else if(error.response.headers["content-type"]
        && error.response.headers["content-type"] === "application/json"){
        // 呼び出し元でハンドリング
        return true;  // ハンドリング要
      }else{
        // 不明な通信エラー
        if(error.message){
          var param = {
            message: error.message
          };
        }else{
          var param = {
            message: "unknown"
          };
        }
        this.$store.commit("setNotification", {
          type: "error",
          message: {
            eid: "E1" + this.module_id + "900" + ":00000002",
            param: param
          }
        });
        return false; // ハンドリング不要
      }
    }
  }
}
